var containerSelector = '#timeline';
var iCacheWidthContainer;
var events = [];
var startYear;
var endYear;
var totalYears = 1;

var urlVars = window.location.search;
var urlNoHash = window.location.pathname + urlVars;

var concat;
if (urlVars == '') {
	concat = '?';
} else {
	concat = '&';
}

$(document).ready(function () {

	if ($(containerSelector).length > 0) {

		getEvents();

		iCacheWidthContainer = $(containerSelector).width();
		
		var tl = $(containerSelector).jqtimeline({
		                                          events : events,
		                                          totalWidth: iCacheWidthContainer,
		                                          click:function(e,event){
		                                              window.location.hash = event.hash;
		                                              hashHighlight(event.hash);
		                                          }});

		$(window).resize(function() {

			var iCurrentWidthContainer = $(containerSelector).width();

			if (iCurrentWidthContainer > iCacheWidthContainer + 10 ||
			    iCurrentWidthContainer < iCacheWidthContainer - 10) {

				$(containerSelector).empty();

				var tl = $(containerSelector).jqtimeline({
				                                          events : events,
				                                          totalWidth: iCurrentWidthContainer,
				                                          click:function(e,event){
				                                              window.location.hash = event.hash;
				                                              hashHighlight(event.hash);
				                                          }});
				iCacheWidthContainer = iCurrentWidthContainer;
			}

		});
	}

});


// Get all the events (from data attributes) that must appear in the timeline.
// IN:
//UIT:
function getEvents() {

	$("#dbv5-no tbody tr").each(function(index) {

		// skip header
		if (index == 0) {
			return 'continue';
		}
		
		// get all data attributes from this tr at once
		var info = $(this).data();

		var id    = info['article.article_id'];
		var title = info['article.cache_header'];
		var hash = '#item' + id;
		var date = getValidDate(info['article.publication_date']);

		// skip when required data is missing
		if (id == '' || title == '' || !date) {
			return 'continue';
		}

		events.push({
			'id'   : id,
			'name' : title,
			'on'   : date,
			'hash' : hash
		});

	});
}


// Creates js Date object.
// IN:  date - string
//UIT: js date
function getValidDate(date) {
	
	if (typeof date === 'string' && date != '') {
		var t = date.split(/[- :]/);
		// if t[3], t[4] and t[5] are missing they default to zero
		return new Date(t[0], t[1] - 1, t[2], t[3] || 0, t[4] || 0, t[5] || 0);
	}
	return null;
}
